export default __webpack_public_path__ + "static/IMG_1260-8e661d897771010544484ae42326c731.jpg";